import React from 'react';

const ExportIcon = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10" stroke="url(#paint0_linear_3074_14295)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M4.6665 6.6665L7.99984 9.99984L11.3332 6.6665" stroke="url(#paint1_linear_3074_14295)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M8 10V2" stroke="url(#paint2_linear_3074_14295)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <defs>
                <linearGradient id="paint0_linear_3074_14295" x1="1.15745" y1="10" x2="14.3098" y2="11.3038" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#32A6AE" />
                    <stop offset="1" stopColor="#00BBA7" />
                </linearGradient>
                <linearGradient id="paint1_linear_3074_14295" x1="4.19842" y1="6.66651" x2="11.545" y2="7.15203" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#32A6AE" />
                    <stop offset="1" stopColor="#00BBA7" />
                </linearGradient>
                <linearGradient id="paint2_linear_3074_14295" x1="7.92979" y1="2" x2="9.03657" y2="2.00457" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#32A6AE" />
                    <stop offset="1" stopColor="#00BBA7" />
                </linearGradient>
            </defs>
        </svg>
    )
}

export default ExportIcon;